import React, { FC, isValidElement, ReactNode, cloneElement } from 'react';
import styled from 'styled-components';
import LinkifyIt from 'linkify-it';

const Link = styled.a`
  font-size: inherit;
`;

const linkify = new LinkifyIt();

const parseString = (str: string): ReactNode => {
  const isSomeUrlExist = linkify.test(str);

  if (!isSomeUrlExist) {
    return str;
  }

  let lastIndex = 0;
  const elements = [];
  const foundedMatches = linkify.match(str);
  foundedMatches.forEach((match) => {
    // Push preceding text if there is any
    if (match.index > lastIndex) {
      elements.push(str.substring(lastIndex, match.index));
    }

    elements.push(
      <Link key={match.index} href={match.url} rel="noopener noreferrer" target="_blank">
        {match.text}
      </Link>
    );

    lastIndex = match.lastIndex;
  });

  // Push remaining text if there is any
  if (str.length > lastIndex) {
    elements.push(str.substring(lastIndex));
  }

  return elements.length === 1 ? elements[0] : elements;
};

const parseElement = (children: ReactNode, key = 0): ReactNode => {
  if (typeof children === 'string') {
    return parseString(children);
  }

  if (isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
    return cloneElement(children, { key }, parseElement(children.props.children));
  }

  if (Array.isArray(children)) {
    return children.map((child, i) => parseElement(child, i));
  }

  return children;
};

const Linkify: FC = ({ children: childrenProp }) => {
  return <>{parseElement(childrenProp)}</>;
};

export default Linkify;
